<mat-icon
  inline
  container="body"
  placement="bottom"
  [popoverTitle]="'Legend'"
  [ngbPopover]="popContent"
  [popoverClass]="'form-legend-popover'">
  help
</mat-icon>

<ng-template #popContent>
  <div class="legend-container">
    <div>
      <span class="form-field-item form-error">Input *</span>
    </div>
    <span class="description">Missing Mandatory field</span>

    <div>
      <span class="form-tab form-error">Tab</span>
    </div>
    <span class="description">Missing Mandatory field in the form</span>

    <div>
      <span class="form-field-item form-required">Input *</span>
    </div>
    <span class="description">Mandatory field to complete</span>

    <div>
      <span class="form-tab form-required">Tab</span>
    </div>
    <span class="description">Mandatory field to complete in the form</span>

    <div>
      <span class="form-field-item form-complete">Input *</span>
    </div>
    <span class="description">Validated Mandatory field</span>

    <div>
      <span class="form-tab form-complete">Tab</span>
    </div>
    <span class="description">All Mandatory field validated</span>

    <div>
      <span class="form-field-item form-default">Input *</span>
    </div>
    <span class="description">Non mandatory field</span>

    <div>
      <span class="form-tab form-default">Tab</span>
    </div>
    <span class="description">Non mandatory field to complete</span>

    <span></span>
    <span></span>
    <div class="form-tab-badge">
      <div class="form-error">
        <span>1</span>
      </div>
    </div>
    <span class="description">Number of mandatory fields missing</span>
  </div>
</ng-template>